"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercisesWrap = exports.Exercise = exports.OpenExerciseButton = exports.Content = exports.ExercisesListWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Accordion_elements_1 = require("@components/common/Accordion/Accordion.elements");
exports.ExercisesListWrap = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 8px;
  min-width: 344px;
  align-items: center;

  box-sizing: border-box;
  margin: 0 auto;

  * {
    box-sizing: border-box;
    margin: 0;
  }

  @media screen and (min-width: 768px) {
    gap: 40px;
  }

  @media screen and (min-width: 1000px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
    padding: 0 0 90px 0;
    max-width: 918px;
  }

  @media screen and (min-width: 1300px) {
    max-width: 1220px;
  }

  @media screen and (min-width: 1690px) {
    max-width: 1354px;
  }

  @media screen and (min-width: 1920px) {
    max-width: 1544px;
  }
`;
exports.Content = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 14px;
  gap: 16px;
  padding: 16px;
  width: 100%;

  h1 {
    font-family: Phenomena, sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    text-align: left;
    color: #333333;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    width: 100%;
  }

  @media screen and (min-width: 1000px) {
    border-radius: 8px;
    gap: 28px;
    padding: 40px;
  }
`;
exports.OpenExerciseButton = styled_components_1.default.a `
  font-family: "GolosTextWebRegular", sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  border: 3px solid #6e77fb;
  padding: 11px;
  width: 66%;
  margin: 20px 0;
  font-size: 18px;
  color: #6e77fb;
  background-color: white;
  cursor: pointer;
  border-radius: 50px;
  text-align: center;
`;
exports.Exercise = styled_components_1.default.button `
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbcbcb;
  background: white;
  font-family: Inter, sans-serif;
  color: #333333;
  cursor: pointer;
`;
exports.ExercisesWrap = styled_components_1.default.div `
  width: 100%;
  //  if only exercises without any category inside
  &.only-exercises {
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${exports.Exercise} {
      width: 100%;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      border-radius: 4px;
      padding: 20px 32px;
    }

    @media screen and (min-width: 768px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 1000px) {
      gap: 24px;
      grid-template-columns: repeat(2, 1fr);

      ${exports.Exercise} {
        //padding: 32px;
        //font-size: 24px;
        //line-height: 30px;
        max-height: 100px;
      }
    }

    @media screen and (min-width: 1300px) {
      gap: 24px;
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 1920px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &.framed-categories {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(3, 87px);
    justify-content: space-between;

    ${exports.Exercise} {
      width: fit-content;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      border-radius: 4px;
      padding: 24px 32px;
    }

    ${Accordion_elements_1.AccordionContent} {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    summary {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }

    details {
      &:not(:has(.non-empty)) {
        display: flex !important;
      }
    }

    & > details[open] {
      grid-column: span 3 / span 3 !important;
    }

    & > details > summary {
      justify-content: center;
    }

    & > details {
      padding: 32px 0;
    }

    & > details[open] {
      padding: 32px 16px;
    }

    & > details[open] > summary {
      justify-content: flex-start;
    }

    @media screen and (min-width: 518px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: 768px) {
      grid-template-columns: repeat(5, 1fr);

      & > details[open] {
        grid-column: span 5 / span 5 !important;
      }

      & > details {
        padding: 32px 0;
      }
    }

    @media screen and (min-width: 1000px) {
      grid-template-columns: repeat(4, 1fr);

      & > details[open] {
        grid-column: span 4 / span 4 !important;
      }

      & > details {
        padding: 35px 0;
        max-width: 114px;
      }

      & > details[open] {
        padding: 35px 32px;
      }
    }

    @media screen and (min-width: 1300px) {
      grid-template-columns: repeat(5, 137px);
      justify-content: flex-start;
      gap: 24px;

      & > details[open] {
        grid-column: span 5 / span 5 !important;
      }

      & > details {
        max-width: 137px;

        //summary {
        //  font-size: 24px;
        //  line-height: 125%;
        //}
      }
    }

    @media screen and (min-width: 1690px) {
      grid-template-columns: repeat(6, 1fr);

      & > details[open] {
        grid-column: span 6 / span 6 !important;
      }
    }

    @media screen and (min-width: 1920px) {
      grid-template-columns: repeat(7, 1fr);

      & > details[open] {
        grid-column: span 7 / span 7 !important;
      }
    }
  }

   &.speech-categories {
       display: flex;
       flex-direction: row;
       flex-wrap: wrap;
   }
    &.default-categories-ipoc {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 28px;

        ${exports.Exercise} {
            width: fit-content;
            font-size: 16px;
            font-weight: 400;
            line-height: 16px;
            border-radius: 4px;
            padding: 24px 32px;
        }

        ${Accordion_elements_1.AccordionContent} {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            padding-top: 10px;
        }

        details {
            &:not(:has(.non-empty)) {
                display: flex !important;
            }
        }

        @media screen and (min-width: 1000px) {
            gap: 48px;

            ${exports.Exercise} {
                font-size: 16px;
                line-height: 16px;
            }
        }
    }
  &.default-categories {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 28px;

    ${exports.Exercise} {
      width: fit-content;
      font-size: 16px;
      font-weight: 400;
      line-height: 16px;
      border-radius: 4px;
      padding: 24px 32px;
    }

    ${Accordion_elements_1.AccordionContent} {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
        justify-content: start;
        align-items: start;
      padding-top: 10px;
    }

    details {
      &:not(:has(.non-empty)) {
        display: flex !important;
      }
    }

    @media screen and (min-width: 1000px) {
      gap: 48px;

      ${exports.Exercise} {
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
`;
